import { IDmQuocTich } from "../../../model/response/category/IDmQuocTich";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eQuocTichActionObj = {
    LOAD_START : undefined,
    LOAD_SUCCESS: {} as IDmQuocTich[],
    LOAD_ERROR: "",
}

export const eQuocTichActionIds = generateActionTypeIds(eQuocTichActionObj,"QUOC_TICH");

export type IQuocTichActionTypes = IGenericActionType<typeof eQuocTichActionObj, "QUOC_TICH">;
